import { render, staticRenderFns } from "./Tableau.vue?vue&type=template&id=79da1a1b&"
import script from "./Tableau.vue?vue&type=script&lang=js&"
export * from "./Tableau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports